
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteTrigger, MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { closeAutocompleteOnOutsideScrollFactory } from 'src/app/services/close-on-outside-scroll-strategy';
import { ActivatedRoute } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { TypeaheadOrder } from 'ngx-bootstrap/typeahead/ngx-bootstrap-typeahead';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { HealthCareOrganization } from 'src/app/services/HealthCareOrganization';
import { UserService } from 'src/app/services/UserService';
import { ApiService } from 'src/app/services/api.service';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobModel } from 'src/app/services/jobModel';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { PricePlanService } from '../Price-subscritions/priceplanService';
import { NgSelectModule } from '@ng-select/ng-select';
import { JobdescriptionparsingService } from 'src/app/services/jobdescriptionparsing.service';
import { NgxSummernoteModule } from 'ngx-summernote';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


  declare var $: any;

// Close mat-autocomplete panels when the form/page scrolls (so the panel
// never floats detached from its input) but NOT while the user scrolls the
// options list itself — same treatment as the Create Job form
// (langding-page-nav-bar). See CloseOnOutsideScrollStrategy.

@Component({
  selector: 'app-job-template',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, NgxSummernoteModule, MatAutocompleteModule,
    CdkScrollableModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './job-template.component.html',
  styleUrls: ['./job-template.component.scss'],
  providers: [
    { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: closeAutocompleteOnOutsideScrollFactory, deps: [NgZone] }
  ]
})
export class JobTemplateComponent extends FormValidation
  implements OnInit, OnDestroy, OnChanges {
  @Output() jobReload = new EventEmitter<any>();
  public FORMERROR = super.Form;
  profileDetailResponse: any;
  private wasInside = false;
  dataPasstoSkillwidgets: Array<any> = [];
  removeTagvalues: any;
  candidateFoundStatus: string = "Fetching candidates ...";
  currentStatusList : { itemId: any; value: any; }[] = []
  inviteStatusList : { itemId: any; value: any; }[] = [];
  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }
  @Input() showtoggle!: boolean;
  @HostListener('document:click')
  clickout() {
    if (!this.wasInside) {
      this.searchData.setjobHighLight('null');
    }
    this.wasInside = false;
  }
  loadDate: any = [];
  flag: boolean = false;
  userType: any;
  applyingJob: boolean = false
  checkedList: any = []
  @Input() applyingCandidate: any;
  @Output() selectedJob: EventEmitter<any> = new EventEmitter()
  @Output() recallfilterAPI: EventEmitter<any> = new EventEmitter()
  @Input() getJobsugg: any;
  @Input() showStatus: any;
  @Input() jobsFoundStatus: any;
  @Input() responseReceived: any;
  @Input() passValues: Array<JobModel> = [];
  @Input() Obj: JobModel | undefined;
  @Input() viewSize: any;
  @Input() loadAPIcall: Boolean | undefined;
  @Input() focus: string | undefined;
  @Input() updateJobModule: jobModuleConfig | undefined;
  jobListing = new EventEmitter<any>();

  downloadurl = AppSettings.photoUrl;
  bsModalRef: BsModalRef | undefined;
  connectionRequestRef: BsModalRef | undefined;
  candidateSupplyRef: BsModalRef | undefined;
  candidateId: any;
  object: any;
  currentTimeDate: string | Date | undefined;
  unit = { duration: '30' };
  selectedJobTitle: string | undefined;
  jobsInvitedToApplyFlag: boolean = false
  // updatedDate: any = new Date();
  rtrformModal: BsModalRef;
  rtrformgrp: UntypedFormGroup

  // @Input() type:any;
  // @Input() data: any;
  userId = localStorage.getItem('userId');

  clickItemActive: any;
  jobId
  seletedChatItem;
  followerFlag: boolean = false
  GigsumoConstant = GigsumoConstants;
  messageData: any;
  messagemodelflag: any;
  @ViewChild('childModal') childModal?: ModalDirective;
  @Output() suggcandidate: EventEmitter<any> = new EventEmitter();
  @ViewChild("myFileInputcandidate") myFileInputcandidate;
  @ViewChild('jobBodycardd', { static: false }) jobBodycardd: ElementRef;

  submited: boolean = false;
  networkflag: boolean = false
  showmodel = false
  creditform: UntypedFormGroup;
  connectionStatus: string;
  values: any;
  counterpartsDetails: any;

  streamRes: any = null;
  jobsResponse: any = [];


  @ViewChild('jobTemplate', { static: false }) jobTemplate: TemplateRef<any>;
  ngunsubscribe = new Subject();
  createSubjectSubscription: Subscription;
  itemsLoaded: boolean = false;
  constructor( private userService: UserService,  private activatedRoute: ActivatedRoute,   public gigsumoService: GigsumoService,
    private util: UtilService, private searchData: SearchData, private a_route: ActivatedRoute,
    private modalService: BsModalService,  private api: ApiService,
    private planService: PricePlanService,
    public jdParsingService: JobdescriptionparsingService  ) {
    super();

    this.userType = localStorage.getItem('userType');
    this.searchData.getjobHighLight().subscribe(res => {
      if (res != 'jobId') {
        this.jobIdHighLight = res
      }
    });

    this.activatedRoute.params.subscribe(response => {
      if (response.networkflag) {
        this.networkflag = true;
      }
      if (response['candidatefilter'] == "true") {
        this.jobsInvitedToApplyFlag = true
      } else {
        this.jobsInvitedToApplyFlag = false
      }
    })

  }
  // Job Description config - blocks images/videos
  config2: any = {
    placeholder: '',
    tabsize: 2,
    height: 150,
    focus: false,
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times'],
    callbacks: {
      onPaste: function(e) {
        // Stop Summernote's Clipboard module from processing images
        e.stopImmediatePropagation();
        e.preventDefault();
        // Only allow plain text
        const bufferText = (e.originalEvent || e).clipboardData.getData('text');
        const cleanText = bufferText.trim();
        document.execCommand('insertText', false, cleanText);
      },
      onImageUpload: function(files) {
        // Block image upload completely
        return false;
      }
    }
  };
  async openJobModal(item) {
    try {
      this.disable_for_draft = false;
      this.editedJob = item;
      this.submit = false;
      this.util.startLoader();
      const orgCheckResponse = await this.api.query('business/check/orgname/' + this.userId).toPromise();

      this.util.stopLoader();
      if (orgCheckResponse.code === '00000' || orgCheckResponse.code === '10008') {
        if (orgCheckResponse.data != null && orgCheckResponse.data.organisation != undefined && orgCheckResponse.data.organisation.length != 0) {
          orgCheckResponse.data.organisation.forEach(ele => {
            this.jobPostedBehalfOflist.push(ele.organizationName);
          });
        }
      }
      this.object = item;
      console.log('Backend experience data:', {
        experienceFrom: this.object.experienceFrom,
        experienceTo: this.object.experienceTo,
        fullObject: this.object
      });
      this.onChangeCountry(item.country);
      await this.initiateJobForm();
      this.currentTimeDate = new Date(this.currentTime);
      if (this.jobTemplate) {
        this.modalRef = this.modalService.show(this.jobTemplate, {
          backdrop: 'static',
          keyboard: false,
          ignoreBackdropClick: true,
          class: 'modal-small',
        });
      }
      this.object.primarySkills.forEach(ele => {
        this.primarySkillsSelected.push(ele);
      });

      this.object.secondarySkills.forEach(ele => {
        this.secondarySkillsSelected.push(ele);
      });


      if (this.object.otherPreferedStates != null && this.object.otherSelectedStates.length > 0) {
        this.object.secondarySkills.forEach(ele => {
          this.secondarySkillsSelected.push(ele);
        });
      }
      if (item.targetRate == 0) {
        item.targetRate = '';
      }
      this.object.duration = this.object.duration!=undefined?this.object.duration:null;
      // Handle experience fields: if both are 0, assume unset/default and convert to null
      if (this.object.experienceFrom === 0 && this.object.experienceTo === 0) {
        this.object.experienceFrom = null;
        this.object.experienceTo = null;
      } else {
        this.object.experienceFrom = this.object.experienceFrom === 0 ? null : this.object.experienceFrom;
        this.object.experienceTo = this.object.experienceTo === 0 ? null : this.object.experienceTo;
      }
      //Patching publishto networks in jobform edit by monisha
      const selectedNetworks = [
        ...(this.object.personalNetworksPublished || []),
        ...(this.object.memberNetworksPublished || []),
        ...(this.object.businessNetworksPublished || []),
      ];
      if (this.object.postedToMarketPlace) {
        selectedNetworks.push({ id: '1', name: 'Marketplace' });
      }
    const networkIds = selectedNetworks.map(network => network.id || network);


      setTimeout(() => {
        this.jobPostForm.patchValue({
          ...this.object,
          selectedNetworks: networkIds ,

        });
      }, 1000);

      if (this.object.clientType == GigsumoConstants.DIRECT_HIRE && this.object.clientName != null) {
        this.jobPostForm.get('clientName').disable();
      }

      if (this.object.jobClassification == 'W2 - Full Time') {
        this.jobPostForm.get('duration').disable();
        this.jobPostForm.get('durationType').disable();
      }
    } catch (error) {
      console.error(error); // Log error for debugging
    } finally {
      this.util.stopLoader();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.passValues != undefined && changes.passValues.currentValue != undefined) {
      this.passValues = changes.passValues.currentValue;
    }
    if (changes.Obj && changes.Obj.currentValue) {
      this.selectedItem = changes.Obj.currentValue.jobId;
    }
  }





  OnChangeCurrentOrg() {
    if (this.jobPostForm.get('clientType').value == GigsumoConstants.DIRECT_HIRE) {
      this.jobPostForm.patchValue({ clientName: this.jobPostForm.get("jobPostedBehalfOf").value })
      this.jobPostForm.get("clientName").disable()
    }
  }


  ngOnInit(): void {
    this.gigsumoService.loadMyBusinessId();
    if(this.userType!="JOB_SEEKER"){
      this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
    }
    this.generateYears()

    this.a_route.queryParams.subscribe((res) => {
      this.candidateId = res.candidateId
      this.jobId = res.jobId
    })

  }

  ngOnDestroy(): void {
    this.ngunsubscribe.next(true);
    this.ngunsubscribe.complete();


  }

  checkConnectionStatus(values): Observable<any> {
    const apiURL = 'user/checkConnectionStatus';
    const params = new HttpParams()
      .set('userId', this.userId)
      .set('connnectorId', values.jobPostedBy);

    const urlWithParams = `${apiURL}?${params.toString()}`;
    return this.api.query(urlWithParams);
  }
  tempApplyValue: any
  jobData: any;
  applyResponse: any = [];
  myCandidatesForApply(jobId: string, candidateSupplyTemplate: any) {
    const responseData: any = {
      "source": {
        "all": false,
        "myCandidates": true,
        "allPlatFormCandidates": false,
        "teamCandidates": false,
        "benchNetworkCandidates": false,
        "freeLancerNetworkCandidates": false,
        "mtaNetworkCandidates": false,
        "jobSeekerNetworkCandidates": false,
        "featured": false,
        "suggestedCandidates": false
      },
      "workType": {
        "all": false,
        "remoteWork": false,
        "relocationRequired": false,
        "workFromHome": false
      },
      "jobId": jobId,
      "workAuthorization": [],
      "engagementType": [],
      "availableIn": [],
      "status": [],
      "searchAfterKey": null,
      "city": null,
      "state": null,
      "country": null,
      "zipCode": null,
      "submissionFilters": [],
      "postedFrom": null,
      "postedTo": null,
      "limit": 10,
      "userId": this.userId,
      "searchContent": ""
    }

    this.api.create('candidates/filter', responseData).subscribe(res => {

      if (res.code === GigsumoConstants.SUCESSCODE) {
        this.applyResponse = res.data.candidateList;
        if (this.applyResponse.length === 0) {
          this.candidateFoundStatus = "Couldn't find any Candidates for the applied filters.";
        }
        const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
        this.candidateSupplyRef = this.modalService.show(candidateSupplyTemplate, config);
      }
    });

  }
  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    this.api.query("user/" + this.values.jobPostedBy).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
      }
    })
  }
  selectedItem: any;
  jobIdHighLight: any
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  closemodel() {
    this.modalRef.hide();
  }
  serverCurrentDate: string;
  servertimedate: string;
  disable_for_draft: boolean = false;
  // Synchronous re-entry guard for saveJob() — see the comment there.
  isSaveInFlight: boolean = false;

  async saveJob(statusvalue: string) {
    // The Activate / Update buttons carry no `disabled` binding at all (only
    // "Save as Draft" does), so a fast double-click on "Edit -> Activate"
    // entered here twice. Both calls reached checkUserPlanValid() ->
    // expiredPopup() and the "Not Enough Jobs / Candidate Slots" popup was
    // shown twice. This flag blocks re-entry synchronously, before the plan
    // check's network round trip goes out.
    if (this.isSaveInFlight) {
      return true;
    }
    this.isSaveInFlight = true;

    this.submit = true
    this.disable_for_draft = true;
    if (statusvalue == 'ACTIVE' && this.jobPostForm.status == "INVALID") {
      this.disable_for_draft = false;
      this.isSaveInFlight = false;
      this.scrollToFirstInvalidControl();
      return true;
    }

    this.jobPostForm.get("status").setValue(this.object.status);
    this.jobPostForm.get("isFeatured").setValue(this.object.isFeatured);

    if (statusvalue == "DRAFTED") {
      for (var allstatus in this.jobPostForm.controls) {
        if (allstatus != 'clientName' && allstatus != 'jobTitle') {

          this.jobPostForm.get(allstatus).clearValidators();

        }
        this.jobPostForm.controls[allstatus].updateValueAndValidity();
      }
      this.jobPostForm.get('status').patchValue('DRAFTED');
    }


    if (this.jobPostForm.valid) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
        buttonsStyling: false
      })


      if (this.object.status == 'DRAFTED' && statusvalue != 'DRAFTED') {

        this.jobPostForm.patchValue({

          "createdByUserType": localStorage.getItem('userType'),

          "status": "ACTIVE"
        })


      }
      if (statusvalue != "DRAFTED") {
        this.savejobafterValdaiton(statusvalue);
      } else {
        this.draftupdatecancel(statusvalue)

      }
      // Short tail so the second click of a double-click is still blocked
      // while the plan check / save request goes out.
      setTimeout(() => {
        this.isSaveInFlight = false;
      }, 500);
    } else {
      this.submit = false
      this.isSaveInFlight = false;
    }
  }

  async savejobafterValdaiton(statusvalue) {
  let updateJobData: any = this.jobPostForm.getRawValue();

  // Convert Year to Years for consistency with UI display
  if (updateJobData.durationType === 'Year') {
    updateJobData.durationType = 'Years';
  }

  if (this.jobPostForm.value.status != "DRAFTED") {
    updateJobData.status = 'ACTIVE';
  }
  //publish to networks sending in api by monisha
  const personalNetworksPublished = (this.selectedNetworks || [])
  .filter((networkId: number) => {
    const network = this.networks.find((n) => n.id === networkId);
    return network && network.type === 'Personal Networks';
  });

 const memberNetworksPublished = (this.selectedNetworks || [])
  .filter((networkId: number) => {
    const network = this.networks.find((n) => n.id === networkId);
    return network && network.type === 'Member Networks';
  });

 const businessNetworksPublished = (this.selectedNetworks || [])
  .filter((networkId: number) => {
    const network = this.networks.find((n) => n.id === networkId);
    return network && network.type === 'Business Networks';
  });

  updateJobData.personalNetworksPublished = personalNetworksPublished;
  updateJobData.memberNetworksPublished = memberNetworksPublished;
  updateJobData.businessNetworksPublished = businessNetworksPublished;
  const isMarketplaceSelected = (this.selectedNetworks || []).map(item => Number(item)).includes(1);
   updateJobData.postedToMarketPlace = isMarketplaceSelected;

  // CEIPAL-only: persist the currency the user sees. If the Country dropdown
  // was never touched, omit currency — the backend keeps the stored ATS value
  // (JobService updateJob null-guard).
  if (this.object?.source === 'CEIPAL' && this.jobControls.country.dirty) {
    updateJobData.currency = this.getCurrency(updateJobData.country);
  }
    const currentStatus: string = updateJobData.status;
    if (this.object.status != 'ACTIVE' && updateJobData.status == 'ACTIVE') {

      const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS", "DEFAULT", () => {
        // Callback when user clicks Upgrade Plan from exhaustion popup
        // Close the Activate Job modal
        if (this.modalRef) {
          this.modalRef.hide();
        }
        // Reset form state
        this.submit = false;
        this.disable_for_draft = false;
        this.isSaveInFlight = false;
      });
      if(!isPlanValid){
        // Slots exhausted — the popup is up. Re-enable the footer buttons
        // (`disable_for_draft` drives styles.scss `.disabled`, which sets
        // pointer-events: none) and clear the re-entry guard so the user can
        // retry after freeing a slot.
        this.disable_for_draft = false;
        this.isSaveInFlight = false;
        return;
      }

    }


    const jobDescription = this.jobPostForm.value.jobDescription || '';
    const cleanedContent = jobDescription.replace(/<img[^>]*>/g, '');
    updateJobData.jobDescription = cleanedContent;
    if (this.membershipType !== 'Free') {
      updateJobData.businessId = localStorage.getItem('myBusinessId') || null;
    }

    // Resolve behalfOfBusinessId from the clientName autocomplete selection
    // (Option C — quadruple-key model). If the user picked from the External
    // Business partition this run, override with the captured ID; otherwise
    // leave whatever value the loaded job had (do not nullify on no-touch edits).
    const currentClientName = this.jobPostForm.get('clientName')?.value;
    if (this.selectedClientSource === 'EXTERNAL'
        && this.selectedClientBusinessId
        && currentClientName === this.selectedClientBusinessName) {
      updateJobData.behalfOfBusinessId = this.selectedClientBusinessId;
    } else if (this.selectedClientSource === 'INTERNAL'
        && currentClientName === this.selectedClientBusinessName) {
      // User explicitly picked a platform business — no behalfOf context.
      updateJobData.behalfOfBusinessId = null;
    }
    // else: untouched / free-text — preserve the job's existing behalfOfBusinessId
    // (which the editor loaded into the model).

    this.util.startLoader()
    this.api.updatePut('jobs/updateJob', updateJobData).subscribe(res => {
      this.jobIdHighLight = this.jobPostForm.value.jobId

      this.util.stopLoader();
      if (res.code == '00000') {
        this.disable_for_draft = false;
        if (this.modalRef) {
          this.modalRef.hide();
        }
        if (res.data.status == 'ACTIVE') {
          res.data.jobData.status = true
        } else if (res.data.status == 'INACTIVE') {
          res.data.jobData.status = false
        }
        Swal.fire({
          position: "center",
          icon: "success",
          title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft updated" : "Job updated"),
          showConfirmButton: false,
          timer: 2000,
        })
          this.jobReload.emit({jobId : updateJobData.jobId ,  status :statusvalue === 'ACTIVE' ? 'updateReload' : 'reload'});
        setTimeout(() => {
          this.submit = false
        }, 4000);

        // Reset JD parsing state
        this.jdParsingService.isJdParsing = false;
        this.jdParsingService.jdParseSuccess = false;
        this.jdParsingService.jdParseFailed = false;
      }
    }, err => {
      this.util.stopLoader();
    });
  }



  draftupdate(statusvalue) {
    this.jobPostForm.get("status").setValue(this.object.status);
    if (this.object.status == 'DRAFTED') {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
        buttonsStyling: false
      })


      swalWithBootstrapButtons.fire({
        title: 'Credit Consumption Alert',
        text: "Credits for this job will be consumed at 12 AM. Would you like to save it as a draft now and create the job, the next day?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.object.status;
          this.jobPostForm.get('status').patchValue('DRAFTED');

          this.savejobafterValdaiton(statusvalue);

        } else {
          this.jobPostForm.get('status').patchValue('ACTIVE');


          if (statusvalue != 'DRAFTED') {
            this.savejobafterValdaiton(statusvalue);
          } else {
            this.commonVariables.jobPostingFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
            if (this.modalRef) {
              this.modalRef.hide();
            }
            this.jobPostForm.reset()
            this.primarySkillsSelected = [];
            this.secondarySkillsSelected = [];


          }

        }

      });
    } else {
      this.savejobafterValdaiton(statusvalue);
    }

  }

  draftupdatecancel(statusvalue) {

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })


    swalWithBootstrapButtons.fire({
      title: 'Save as Draft',
      text: "Would you like to save it as a draft? You can edit this later and save. If No is selected,all the changes will be lost.",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      allowOutsideClick: false,
      allowEscapeKey: false,
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.object.status;
        this.jobPostForm.get('status').patchValue('DRAFTED');

        this.savejobafterValdaiton(statusvalue);

      } else {
        this.jobPostForm.get('status').patchValue('ACTIVE');


        if (statusvalue != 'DRAFTED') {
          this.savejobafterValdaiton(statusvalue);
        } else {
          this.commonVariables.jobPostingFlag = false
          this.searchData.setCommonVariables(this.commonVariables)
          if (this.modalRef) {
            this.modalRef.hide();
          }
          this.jobPostForm.reset()
          this.primarySkillsSelected = [];
          this.secondarySkillsSelected = [];


        }

      }

    });

  }
  otherSelectedStates: any = []

  scrollToFirstInvalidControl() {
    const firstInvalidControl = document.querySelector('form .ng-invalid') as HTMLElement;
    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidControl.focus();
    }
  }

  cancelJob() {
    this.submit = false;
    this.jobPostForm.get("status").setValue(this.object.status);
    if (this.object.status == 'DRAFTED') {
      if (this.jobPostForm.getRawValue().clientName != null && this.jobPostForm.value.jobTitle != null) {
        this.jobPostForm.get('status').patchValue('DRAFTED');
        this.draftupdatecancel('DRAFTED');
      } else {
        this.commonVariables.jobPostingFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
        if (this.modalRef) {
          this.modalRef.hide();
        }
        this.jobPostForm.reset()
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];
        this.otherSelectedStates = []

        // Reset JD parsing state
        this.jdParsingService.isJdParsing = false;
        this.jdParsingService.jdParseSuccess = false;
        this.jdParsingService.jdParseFailed = false;
      }
    } else if (this.object.status != 'ACTIVE' && this.object.status != 'DRAFTED') {
      // For Activate Job modal, close immediately without confirmation
      this.commonVariables.jobPostingFlag = false
      this.searchData.setCommonVariables(this.commonVariables)
      if (this.modalRef) {
        this.modalRef.hide();
      }
      this.jobPostForm.reset()
      this.primarySkillsSelected = [];
      this.secondarySkillsSelected = [];
      this.otherSelectedStates = []

      // Reset JD parsing state
      this.jdParsingService.isJdParsing = false;
      this.jdParsingService.jdParseSuccess = false;
      this.jdParsingService.jdParseFailed = false;
    } else {
      this.activejobcancel();
    }
  }
  activejobcancel() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })


    swalWithBootstrapButtons.fire({
      title: 'Cancel Editing?',
      text: "You might lose the changes you made recently if you do so. You want to continue?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      allowOutsideClick: false,
      allowEscapeKey: false,
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.commonVariables.jobPostingFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
        if (this.modalRef) {
          this.modalRef.hide();
        }
        this.jobPostForm.reset()
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];

        // Reset JD parsing state
        this.jdParsingService.isJdParsing = false;
        this.jdParsingService.jdParseSuccess = false;
        this.jdParsingService.jdParseFailed = false;
      }
    });
  }

  validateLast(year) {

    var fromYear = this.jobPostForm.value.experienceFrom
    if (fromYear != null) {
      if (fromYear > year) {
        return true
      } else {
        return false
      }
    }
  }

  zipCodeValidaiton(x: number): boolean {
    if (String(x).length > 10) {
      return false;
    }
    return true;
  }

  autoComplete1: MatAutocompleteTrigger;
  searchBarShow1: boolean = false
  uniqueOrgList1: Array<Partial<HealthCareOrganization>> = [];
  platformOrgList1: Array<Partial<HealthCareOrganization>> = [];
  externalOrgList1: Array<any> = [];
  clientNameSearched1: boolean = false;

  onPaste1(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    if (pastedText != null) {
      this.util.startLoader();
      this.api.query("care/organizations?organizationName=" + pastedText)
        .pipe(debounceTime(2000))
        .subscribe((res) => {
          this.util.stopLoader();
          if (res) {
            this.util.stopLoader();
            const orgList1: Array<Partial<HealthCareOrganization>> = [];

            res.forEach(ele => {
              var obj: any = {}
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.address1 = ele.address1;
              obj.zipCode = ele.zipCode;
              obj.address2 = ele.address2;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList1.push(obj);
            });
            const uniqueList = new Set(orgList1);
            this.uniqueOrgList1 = Array.from(uniqueList);
            this.platformOrgList1 = Array.from(uniqueList);
          }
        }, err => {
        });

      const loggedInBusinessId = localStorage.getItem('myBusinessId');
      if (loggedInBusinessId) {
        this.api.create('agreementDocumentChecklist/findExternalConnections', {
          businessId: loggedInBusinessId,
          roleFilter: 'Client',
          searchContent: pastedText
        }).subscribe({
          next: (extRes: any) => {
            const externals = extRes?.data?.customerFilters || [];
            this.externalOrgList1 = externals.map((ext: any) => ({
              organizationId: ext.businessId,
              organizationName: ext.businessName,
              businessId: ext.businessId,
              source: 'EXTERNAL'
            }));
          },
          error: () => {
            this.externalOrgList1 = [];
          }
        });
      } else {
        this.externalOrgList1 = [];
      }

      this.searchBarShow1 = true;
    } else {
      this.searchBarShow1 = false
      this.platformOrgList1 = [];
      this.externalOrgList1 = [];
    }
  }

  getOrganization1(value) {
    const trimmed = (value ?? '').toString().trim();
    // Free-text edit invalidates the prior autocomplete selection.
    if (trimmed !== this.selectedClientBusinessName) {
      this.selectedClientBusinessId = '';
      this.selectedClientBusinessName = '';
      this.selectedClientSource = '';
    }
    if (trimmed === '') {
      this.searchBarShow1 = false;
      this.clientNameSearched1 = false;
      this.platformOrgList1 = [];
      this.externalOrgList1 = [];
      this.uniqueOrgList1 = [];
      return;
    }

    this.searchBarShow1 = true;
    this.clientNameSearched1 = false;

    this.api.query("care/organizations?organizationName=" + encodeURIComponent(trimmed))
      .pipe(debounceTime(500))
      .subscribe({
        next: (res: any) => {
          const orgList1: Array<Partial<HealthCareOrganization>> = [];
          if (Array.isArray(res)) {
            res.forEach(ele => {
              const obj: any = {};
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.address1 = ele.address1;
              obj.address2 = ele.address2;
              obj.zipCode = ele.zipCode;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.businessId = ele.businessId;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList1.push(obj);
            });
          }
          this.platformOrgList1 = orgList1;
          this.uniqueOrgList1 = orgList1;
          this.clientNameSearched1 = true;
        },
        error: () => {
          this.platformOrgList1 = [];
          this.uniqueOrgList1 = [];
          this.clientNameSearched1 = true;
        }
      });

    const loggedInBusinessId = localStorage.getItem('myBusinessId');
    if (loggedInBusinessId) {
      this.api.create('agreementDocumentChecklist/findExternalConnections', {
        businessId: loggedInBusinessId,
        roleFilter: 'Client',
        searchContent: trimmed
      }).subscribe({
        next: (extRes: any) => {
          const externals = extRes?.data?.customerFilters || [];
          const needle = trimmed.toLowerCase();
          this.externalOrgList1 = externals
            .filter((ext: any) =>
              ext?.businessName && ext.businessName.toLowerCase().indexOf(needle) !== -1)
            .map((ext: any) => ({
              organizationId: ext.businessId,
              organizationName: ext.businessName,
              businessId: ext.businessId,
              source: 'EXTERNAL'
            }));
          this.clientNameSearched1 = true;
        },
        error: () => {
          this.externalOrgList1 = [];
          this.clientNameSearched1 = true;
        }
      });
    } else {
      this.externalOrgList1 = [];
    }
  }


  organizationList: any = []
  primarySkillsList: any = []
  secondarySkillsList: any = []
  skillsList: any = []
  payTypeList: any = []
  clientTypeList: any = []
  clientNameList: any = []
  clientNameList1: any = []
  durationTypeList: any = []
  usStatesList = []
  jobClassificationList: any = []
  totalExperienceList = []
  periodList = []

  FormData: any;
  uploadFiles: Array<any> = [];
  recruiterTitleList: any = []
  engagementTypeList = []
  workAuthorizationList: any = []
  jobPostForm: UntypedFormGroup;

  onClientTypeChange(value) {

    if (this.userType != 'FREELANCE_RECRUITER') {

      if (value == GigsumoConstants.DIRECT_HIRE) {
        this.jobPostForm.patchValue({ clientName: this.jobPostedBehalfOflist[0] })
        this.jobPostForm.get('clientName').disable()
      } else {
        this.jobPostForm.get('clientName').enable()
        this.jobPostForm.get('clientName').patchValue(null)
      }
    } else if (this.userType == 'FREELANCE_RECRUITER') {
      if (value == GigsumoConstants.DIRECT_HIRE) {
        if (this.jobPostForm.get('jobPostedBehalfOf').value != null) {
          this.jobPostForm.patchValue({ clientName: this.jobPostForm.get('jobPostedBehalfOf').value })
          this.jobPostForm.get('clientName').disable()
        } else {
          this.jobPostForm.get('clientName').patchValue(null)
          this.jobPostForm.get('clientName').enable()
        }
      } else {
        this.jobPostForm.get('clientName').patchValue(null)
        this.jobPostForm.get('clientName').enable()
      }
    }
  }

  years: any = []
  Toyears: any = []
  generateYears() {
    this.years = []
    this.Toyears = []

    for (var i = 0; i <= 20; i++) {
      this.years.push(i);
    }
    for (var i = 1; i <= 20; i++) {
      this.Toyears.push(i);
    }
  }

  years2: any = []
  generateYears2() {
    this.years2 = []

    for (var i = 1; i <= 20; i++) {
      this.years2.push(i);
    }
  }

  years1: any = []
  generateYears1() {
    this.years1 = []
    var max = new Date().getFullYear();
    var min = max - 80;
    for (var i = min; i <= max; i++) {
      this.years1.push(i);
    }
  }

  primarySkillsSelected = [];
  secondarySkillsSelected = [];

  // ng-select's clear-all (the "x" on the field) only marks itself for check.
  // Its dropdown panel is a separate OnPush child that keeps the same [items]
  // reference, so the option rows kept showing the old checked state until the
  // mouse moved over the list. Hand the panel a fresh array reference on clear
  // so it re-renders at once.
  onSkillsCleared(field: 'primary' | 'secondary') {
    if (field === 'primary') {
      this.primarySkillsList = [...this.primarySkillsList];
    } else {
      this.secondarySkillsList = [...this.secondarySkillsList];
    }
  }
  stateListCA: any = []
  stateListIN: any = []
  stateListAU: any = []
  countryList: any = [];
  submit: boolean = false;
  currentTime: any;
  maxDate: any
  isSelected(id: number): boolean {
    return this.gigsumoService.isSelected(id, this.selectedNetworks);
  }

  onCheckboxChangenetwork(id: number, checked: boolean, form: FormGroup): void {
    this.selectedNetworks = this.gigsumoService.onCheckboxChange(
      id,
      checked,
      this.selectedNetworks,
      form,
      'selectedNetworks'
    );
  }

  onNetworkSelectionChange(form: FormGroup): void {
    // Strip disabled networks (safety net)
    this.selectedNetworks = this.selectedNetworks.filter((n: any) => {
      const network = this.networkGroups.find((g: any) => String(g.id) === String(n?.id || n));
      return !network?.disabled;
    });
    // Re-add locked networks if removed
    this.lockedNetworkIds.forEach(lockedId => {
      if (!this.selectedNetworks.some((n: any) => String(n?.id || n) === lockedId)) {
        this.selectedNetworks = [...this.selectedNetworks, lockedId];
      }
    });
    // Prevent Free plan users from unchecking Marketplace
    if (this.membershipType === 'Free') {
      const hasMarketplace = this.selectedNetworks.some((id: any) => id === '1' || id === 1);
      if (!hasMarketplace) {
        this.selectedNetworks = ['1', ...this.selectedNetworks];
      }
    }
    form.get('selectedNetworks')?.setValue(this.selectedNetworks);
  }

  selectedNetworks: any[] = [];
  networkGroups: any[] = [];
  networks: any[] = [];
  membershipType = localStorage.getItem('MemberShipType');
  groupedNetworks: any = {};
  lockedNetworkIds: Set<string> = new Set();
  disabledNetworkTypes: Set<string> = new Set();

  isNetworkLocked(networkId: any): boolean {
    return this.lockedNetworkIds.has(String(networkId));
  }

  isNetworkDisabledByPermission(network: any): boolean {
    if (!network) return false;
    if (network.id === '1') return this.disabledNetworkTypes.has('Marketplace');
    return this.disabledNetworkTypes.has(network.type);
  }
  getListValues(param) {
    this.clientTypeList = []
    this.payTypeList = []
    this.secondarySkillsList = []
    this.primarySkillsList = []
    this.skillsList = []
    this.periodList = []
    this.recruiterTitleList = []
    this.totalExperienceList = []
    this.workAuthorizationList = []
    this.durationTypeList = []
    this.engagementTypeList = []

    if (this.jobClassificationList.length == 0) {
      this.util.startLoader()
      var data: any = { "domain": "JOB_ENGAGEMENT_TYPES,JOB_CLIENT_TYPES,PAY_TYPE,DURATION,PRIMARY_SKILLS,WORK_AUTHORIZATION,CANDIDATE_AVAILABLITY,TOTAL_EXPERIENCE,SECONDARY_SKILLS,GIGSUMO_SKILLS_LIST,GIGSUMO_JOB_TITLE,GIGSUMO_RECRUITERS_TITLE_LIST,EFFECTIVE_FOR" }
      data.userId = localStorage.getItem("userId");
       data.type="NETWORKS"
      this.api.create('listvalue/findbyList', data).subscribe(res => {
        if (res.code == '00000') {
          const data = res.data;
          //getting publish to networks in list values by monisha
          const businessNetworks = data.businessNetworks ? data.businessNetworks.map((network: any) => ({
            id: network.b2bNetworkId,
            name: network.b2bNetworkName,
            type: 'Business Networks'
          })) : [];

          const memberNetworks = data.memberNetworks ? data.memberNetworks.map((network: any) => ({
            id: network.businessNetworkId,
            name: network.businessNetworkName,
            type: 'Member Networks'
          })) : [];

          const personalNetworks = data.personalNetworks ? data.personalNetworks.map((network: any) => ({
            id: network.networkId,
            name: network.networkName,
            type: 'Personal Networks'
          })) : [];
          const allNetworks = [...businessNetworks, ...memberNetworks, ...personalNetworks];

          this.networks = allNetworks;
          // Group networks by type
          this.groupedNetworks = allNetworks.reduce((groups: any, network: any) => {
            const { type } = network;
            if (!groups[type]) {
              groups[type] = [];
            }
            groups[type].push(network);
            return groups;
          }, {});
          this.networkGroups = Object.keys(this.groupedNetworks).reduce((result: any[], type: string) => {
            return result.concat(this.groupedNetworks[type].map((network: any) => ({
              ...network,
              type
            })));
          }, []);
          const marketplaceNetwork = {
            id: '1', // Assign a unique ID
            name: 'Marketplace',
            type: 'Marketplace'
          };
          this.networkGroups = [marketplaceNetwork, ...this.networkGroups];

          // Pre-select Marketplace for Free plan users
          if (this.membershipType === 'Free' && this.selectedNetworks !=null) {
            const hasMarketplace = this.selectedNetworks.some(id => id === '1' || id === 1);
            if (!hasMarketplace) {
              this.selectedNetworks = ['1', ...this.selectedNetworks];
            }
          }

          // Apply org-level publish settings (locked + disabled networks)
          const bizId = localStorage.getItem('myBusinessId');
          if (bizId) {
            this.api.query(`business/getNetworkPermissions?businessId=${bizId}`).subscribe({
              next: (settingsRes: any) => {
                const sData = settingsRes?.data || {};
                const schedule: any[] = sData.publishSchedule || [];
                const day1Step = schedule.find((s: any) => s.day === 1);
                const day1Ids: string[] = day1Step
                  ? [
                      ...((day1Step.b2bNetworkIds as string[]) || []),
                      ...((day1Step.personalNetworkIds as string[]) || []),
                      ...((day1Step.memberNetworkIds as string[]) || []),
                      ...(day1Step.marketplace ? ['1'] : [])
                    ]
                  : [];
                this.lockedNetworkIds = new Set<string>(day1Ids.map(String));
                day1Ids.forEach(id => {
                  if (!this.selectedNetworks.some((n: any) => String(n?.id || n) === id)) {
                    this.selectedNetworks = [...this.selectedNetworks, id];
                  }
                });
                const perms = sData.networkPermissions;
                this.disabledNetworkTypes = new Set<string>();
                if (perms) {
                  if (perms.personalNetworks === false) this.disabledNetworkTypes.add('Personal Networks');
                  if (perms.memberNetworks === false) this.disabledNetworkTypes.add('Member Networks');
                  if (perms.b2bNetworks === false) this.disabledNetworkTypes.add('Business Networks');
                  if (perms.marketplace === false) this.disabledNetworkTypes.add('Marketplace');
                }
                this.networkGroups = this.networkGroups.map((n: any) => ({
                  ...n,
                  disabled: this.isNetworkDisabledByPermission(n)
                }));
              },
              error: () => {}
            });
          }

          this.currentTime = new Date(res.data.currentTime);

          if (param == 'CANDIDATE') {
            this.usStatesList = []
            this.api
              .query("country/getAllStates?countryCode=US")
              .subscribe((res) => {
                if (res) {
                  res.forEach(ele => {
                    this.usStatesList.push(ele.stateName)
                    this.otherStatesList.push(ele.stateName)
                  })
                }
              }, err => {
                this.util.stopLoader();
              })
          }


          res.data.JOB_CLIENT_TYPES.listItems.forEach(ele => {
            this.clientTypeList.push(ele.item);
          })
          res.data.PAY_TYPE.listItems.forEach(ele => {
            this.payTypeList.push(ele.item)
          })
          res.data.GIGSUMO_SKILLS_LIST.listItems.forEach(ele => {
            this.skillsList.push(ele.item)
          })
          res.data.PRIMARY_SKILLS.listItems.forEach(ele => {
            if (ele.item) {
              this.primarySkillsList.push(ele.item)
              var mySet = new Set(this.primarySkillsList);
              this.primarySkillsList = [...mySet]
            }
          })
          res.data.SECONDARY_SKILLS.listItems.forEach(ele => {
            if (ele.item) {
              this.secondarySkillsList.push(ele.item)
              var mySet = new Set(this.secondarySkillsList);
              this.secondarySkillsList = [...mySet]
            }
          })
          res.data.CANDIDATE_AVAILABLITY.listItems.forEach(ele => {
            this.periodList.push(ele.item)
          })

          res.data.TOTAL_EXPERIENCE.listItems.forEach(ele => {
            this.totalExperienceList.push(ele.item)
          })
          res.data.JOB_ENGAGEMENT_TYPES.listItems.forEach(ele => {
            this.engagementTypeList.push(ele.item)
          })
          res.data.WORK_AUTHORIZATION.listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
          })
          res.data.DURATION.listItems.forEach(ele => {
            this.durationTypeList.push(ele.item)
          })
          res.data.GIGSUMO_JOB_TITLE.listItems.forEach(ele => {
            this.candidateJobTitleList.push(ele.item)
            var mySet = new Set(this.candidateJobTitleList);
            this.candidateJobTitleList = [...mySet]
          })
          res.data.GIGSUMO_RECRUITERS_TITLE_LIST.listItems.forEach(ele => {
            this.recruiterTitleList.push(ele.item)
          })
          if (param == 'CANDIDATE') {
            // this.util.stopLoader()
            this.commonVariables.jobPostingFlag = false
            this.commonVariables.candidatePostingFlag = true
            this.commonVariables.postPrivacyFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
          } else if (param == 'JOBS') {
            // this.util.stopLoader()
            this.commonVariables.jobPostingFlag = true
            this.commonVariables.postPrivacyFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
          }
        }
      })
    } else {
      if (param == 'CANDIDATE') {
        this.util.stopLoader()
        this.commonVariables.jobPostingFlag = false
        this.commonVariables.candidatePostingFlag = true
        this.commonVariables.postPrivacyFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
      } else if (param == 'JOBS') {
        this.util.stopLoader()
        this.commonVariables.jobPostingFlag = true
        this.commonVariables.postPrivacyFlag = false
        this.searchData.setCommonVariables(this.commonVariables)
      }
    }
  }

  onChangePeriod(value) {

  }


  payType: null;
  targetRate: null;
  figureLength: number = 0;
  selectedCountries: boolean = false
  typeTargetValue: null;
  countryChosen: null;
  onChangeCountry(event) {
    this.countryChosen = event;
    if (this.countryChosen != undefined && this.jobPostForm != undefined) {
      if (this.countryChosen != 'US' || this.countryChosen != 'AU' || this.countryChosen != 'IN' || this.countryChosen != 'CA') {
        this.jobPostForm.get('city').patchValue(null)
        this.jobPostForm.get('state').patchValue(null)
        this.jobPostForm.get('zipCode').patchValue(null)
      }
    }


    if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Hourly') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Daily') {
      this.figureLength = 3
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Monthly') {
      this.figureLength = 6
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Weekly') {
      this.figureLength = 5
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Yearly') {
      this.figureLength = 8
    } else if (this.countryChosen == 'IN' && this.payType == 'Hourly') {
      this.figureLength = 4
    } else if (this.countryChosen == 'IN' && this.payType == 'Daily') {
      this.figureLength = 5
    } else if (this.countryChosen == 'IN' && this.payType == 'Monthly') {
      this.figureLength = 7
    } else if (this.countryChosen == 'IN' && this.payType == 'Weekly') {
      this.figureLength = 6
    } else if (this.countryChosen == 'IN' && this.payType == 'Yearly') {
      this.figureLength = 8
    }


    if (event == "US") {
      this.selectedCountries = true
      const countryCode = event;
      this.util.startLoader()
      this.workAuthorizationList = []
      this.api.query('listvalue/find?domain=WORK_AUTHORIZATION_US').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
          });
          this.usStatesList = [];
          if (this.usStatesList.length == 0) {
            this.api
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                res.forEach(ele => {
                  if (res && res.length > 0) {
                    this.jobPostForm.get('state').clearValidators();
                    this.jobPostForm.get('state').updateValueAndValidity();
                  }
                  this.usStatesList.push(ele.stateName)
                })
              }, err => {
                this.util.stopLoader();
              });
            // }
          }
        }
      })

    } else if (event == "AU") {
      this.workAuthorizationList = []
      this.util.startLoader()
      this.api.query('listvalue/find?domain=WORK_AUTHORIZATION_AU').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
          })

          this.selectedCountries = true
          const countryCode = event;
          if (this.stateListAU.length == 0) {
            this.stateListAU = [];

            this.api
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                if (res && res.length > 0) {
                  this.jobPostForm.get('state').clearValidators();
                  this.jobPostForm.get('state').updateValueAndValidity();
                }
                this.stateListAU = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })

    } else if (event == "IN") {
      this.workAuthorizationList = []
      this.util.startLoader()
      this.api.query('listvalue/find?domain=WORK_AUTHORIZATION_IN').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
          })


          this.selectedCountries = true
          const countryCode = event;
          if (this.stateListIN.length == 0) {
            this.stateListIN = [];

            this.api
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                if (res && res.length > 0) {
                  this.jobPostForm.get('state').clearValidators();
                  this.jobPostForm.get('state').updateValueAndValidity();
                }
                this.stateListIN = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })


    } else if (event == "CA") {
      this.workAuthorizationList = []
      this.util.startLoader()
      this.api.query('listvalue/find?domain=WORK_AUTHORIZATION_CA').subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
          })

          this.selectedCountries = true
          const countryCode = event;


          if (this.stateListCA.length == 0) {
            this.api
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                if (res && res.length > 0) {
                  this.jobPostForm.get('state').clearValidators();
                  this.jobPostForm.get('state').updateValueAndValidity();
                }
                this.stateListCA = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })

    } else {
      this.selectedCountries = false

    }
    if (this.typeTargetValue != null) {
      this.onTargetRateTyped(this.typeTargetValue)
    }

  }





  commonVariables: any = {};

  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }

  get jobControls() {
    return this.jobPostForm.controls
  }

  // JD Parsing state getters
  get isJdParsing(): boolean {
    return this.jdParsingService.isJdParsing;
  }

  get jdParseSuccess(): boolean {
    return this.jdParsingService.jdParseSuccess;
  }

  get jdParseFailed(): boolean {
    return this.jdParsingService.jdParseFailed;
  }

  // Parse job description method
  parseJobDescription(): void {
    // Initialize JD parsing service with form and config
    this.jdParsingService.patchFormToService(this.jobPostForm, {
      engagementTypeList: this.engagementTypeList,
      payTypeList: this.payTypeList,
      countryList: this.countryList,
      years: this.years,
      Toyears: this.Toyears,
      years2: this.years2,
      durationTypeList: this.durationTypeList,
      usStatesList: this.usStatesList,
      stateListCA: this.stateListCA,
      stateListIN: this.stateListIN,
      stateListAU: this.stateListAU
    });
    this.jdParsingService.parseJobDescription();
  }

  noResult: boolean = false
  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
    this.jobPostForm.patchValue({
      organisationId: null
    })
  }
  onengagementTypeChange(value: string) {
    if (value.includes('W2 - Full Time')) {
      this.jobPostForm.get('duration').disable();
      this.jobPostForm.get('durationType').disable();
      this.jobPostForm.get('duration').reset();
      this.jobPostForm.get('durationType').reset();
    } else {
      this.jobPostForm.get('duration').enable();
      this.jobPostForm.get('durationType').enable();
      this.jobPostForm.get('durationType').patchValue('Months');
    }
  }

  // Tracks the most recent clientName autocomplete selection so savejobafterValdaiton
  // can resolve behalfOfBusinessId. Free-text edits reset these via getOrganization1.
  selectedClientBusinessId: string = '';
  selectedClientBusinessName: string = '';
  selectedClientSource: 'EXTERNAL' | 'INTERNAL' | '' = '';

  onChngOrg(event, source: 'INTERNAL' | 'EXTERNAL' = 'INTERNAL') {

    this.jobPostForm.patchValue({
      organisationId: event.organizationId
    })

    this.selectedClientBusinessId = event.organizationId || event.businessId || '';
    this.selectedClientBusinessName = event.organizationName || '';
    this.selectedClientSource = source;
  }


  sortConfigWork: TypeaheadOrder = {
    direction: "desc",
    field: "organisationName",
  };

  validateBeginning(year) {
    // var fromYear = this.jobPostForm.value.experienceFrom
    var toYear = this.jobPostForm.value.experienceTo
    if (toYear != null) {
      if (year > toYear) {
        return true
      } else {
        return false
      }
    }
  }

 ;

  onChangePayType(value, param) {
    this.payType = value
    // if (this.countryChosen != null) {
    if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Hourly') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Daily') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Monthly') {
      this.figureLength = 6
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Weekly') {
      this.figureLength = 5
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Yearly') {
      this.figureLength = 8
    } else if (this.countryChosen == 'IN' && this.payType == 'Hourly') {
      this.figureLength = 4
    } else if (this.countryChosen == 'IN' && this.payType == 'Daily') {
      this.figureLength = 5
    } else if (this.countryChosen == 'IN' && this.payType == 'Monthly') {
      this.figureLength = 7
    } else if (this.countryChosen == 'IN' && this.payType == 'Weekly') {
      this.figureLength = 6
    } else if (this.countryChosen == 'IN' && this.payType == 'Yearly') {
      this.figureLength = 8
    }
    // }
    if (this.typeTargetValue != null) {
      this.onTargetRateTyped(this.typeTargetValue)
    }

  }

  onTargetRateTyped(value) {
    this.typeTargetValue = value

  }

  candidateJobTitleList: any = []
  jobPostedBehalfOflist: any = []
  modalRef: BsModalRef;
  otherStatesList: any = [];
  editedJob: Partial<JobModel>

  getCountries() {
    this.countryList = [];
    this.util.startLoader();
    this.api.query("country/getAllCountries").subscribe((res) => {
      res.forEach((ele) => {
        this.countryList.push(ele);
      });
    }, err => {
      this.util.stopLoader();
    });
  }






  async initiateJobForm() {
    try {
      this.util.startLoader();
      await Promise.all([
        this.getCountries(),
        this.getListValues('JOBS'),
        this.generateYears(),
        this.generateYears2(),
      ]);
      this.jobPostForm = new AppSettings().getEditJobFormGroup();

      
    } catch (error) {
    } finally {
      this.util.stopLoader();
    }
  }

  deletedraft(id: any) {

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: 'Do you wish to discard?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.util.startLoader();
        this.api.delete('jobs/delete/' + id).subscribe(res => {
          if (res.code == "00000") {
            this.util.stopLoader();
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Discarded Sucessfully',
              showConfirmButton: false,
              timer: 1500
            })
            this.jobReload.emit("reload");

          }
        })
      }
    })
      ;
  }
}







